import { colors } from '../../Colors/colors'

export const customObjectTheme = {
   light: {
      relations: {
         relationListHeader: {
            titleTextColor: 'text-gray-500'
         },
         relationsHeader: {
            plusIconColor: colors['base-white'],
            containerBorderColor: 'border-gray-300',
            titleTextColor: 'text-gray-900'
         },
         noRelationsView: {
            plusIconColor: colors['base-white']
         },
         relationCard: {
            containerBgColor: 'bg-base-white',
            nameTextColor: 'text-gray-800',
            objectTextColor: 'text-gray-600',
            cardinalityTextColor: 'text-gray-600',
            cardinalityStrongTextColor: 'text-gray-800',
            actionsMenuIconColor: colors['gray-500'],
            editIconColor: colors['gray-500'],
            editTextColor: 'text-gray-900',
            popoverBorderColor: 'border-gray-200',
            popoverBgColor: 'bg-base-white',
            popoverTriggerHoverColor: 'hover:bg-gray-50',
            popoverTriggerActiveColor: 'bg-gray-50',
            actionHoverBgColor: 'hover:bg-gray-50'
         },
         relationsSidePane: {
            labelTextColor: 'text-gray-700',
            footerBorderColor: 'border-gray-300',
            closeIconColor: colors['gray-500'],
            headerBorderColor: 'border-gray-300',
            titleTextColor: 'text-gray-900',
            descriptionTextColor: 'text-gray-600',
            navigationItemBorderColor: 'border-gray-300',
            rightIconColor: colors['gray-500'],
            navigationItemTextColor: 'text-gray-800',
            permissionsHeaderTextColor: 'text-gray-900'
         },
         displaySidePane: {
            headerBorderColor: 'border-gray-300',
            titleTextColor: 'text-gray-900',
            iconColor: colors['gray-500'],
            borderColor: 'border-gray-100',
            selectedFieldsBorderColor: 'border-gray-100',
            noResultsTextColor: 'text-gray-500'
         }
      },
      createCustomObjectSystemField: {
         defaultIconColor: colors['gray-500'],
         defaultBorderColor: 'border-gray-300',
         optionHoverStyles: 'hover:bg-gray-50',
         checkIconColor: colors['primary-600'],
         separationLineColor: 'bg-gray-300 border-t-gray-300',
         fieldTypeOption: 'text-gray-700',
         headerTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600'
      }
   },
   dark: {}
}
